<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3mZWI7/tc-custom/9781504075039.jpg?1718183453192" alt="This image is the cover for the book Vigilante, The Ryker Returns Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vigilante, The Ryker Returns Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>From the author of <i>The Red Cobra</i>, a new thriller featuring a spy on a journey across Europe in search of a killer . . .</b><br/>  <br/> James Ryker thought he’d gotten the gangsters out of the Norwegian town of Blodstein, so when he hears of a wave of murders, it gets his attention. Then he discovers that an unidentified teenager has been found dead in Crete, and the description of the victim raises an alarm—could the boy be Henrik Svenson, who Ryker had once rescued in Blodstein?<br/>  <br/> To get some answers, Ryker heads for Athens—and meets the seductive but duplicitous Eleni. Soon the search begins for a known associate of the elusive Eastern European drug kingpin known only as Jesper. But just as it looks like he’s about to get a break in the case, Ryker finds himself in jail for murder.<br/>  <br/> Someone is setting him up—and after two Russian agents visit him in prison, things take a turn he never expected . . .<br/>  <br/><b>Praise for the bestselling novels of Rob Sinclair</b><br/>  <br/> “A real page-turner, impossible to put down.” —<i>Publishers Weekly</i><br/>  <br/> “A must read for fans of Lee Child and Robert Ludlum.” —<i>Chelle’s Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Sinclair
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?364ee03d